<template>
    <el-card>
        <el-form :model="detailForm" label-width="120px">

            <el-form-item label="所在目录:">
                <span>{{ detailForm.parent_name }}</span>
            </el-form-item>

            <el-form-item label="应用名称:">
                <span>{{ detailForm.name }}</span>
            </el-form-item>

            <el-form-item label="应用图标:">
                <img :src='detailForm.img_url' style='width: 20px; height: 20px;'/>
            </el-form-item>

            <el-form-item label="负责人:">
                <span>{{detailForm.superviser}}</span>
            </el-form-item>

            <el-form-item label="邮件组:">
                <span>{{ detailForm.mail }}</span>
            </el-form-item>

            <el-form-item>
                <router-link :to="{ path: '/appcenterMenuAdd',
                                    query: { type:'edit',
                                            appnodeId: detailForm.id,
                                            count: {},
                                            callback: getDetail
                                        }}">
                    <el-button type="primary" v-w-role="'ITSM-0103'"  @click="isEdited">编辑</el-button>
                    <!--//v-w-role="'cicdCxjcYysYybj'"-->
                </router-link>

                <el-button type="danger" @click="handleDel(detailForm.id)" v-w-role="'ITSM-0104'">删除</el-button>
            </el-form-item>

        </el-form>
    </el-card>
</template>

<script>
    import services from '../../cicd.services'
    export default {

        data() {
            return {
                typeList: [],
                index: 0,
                tabVal: '',
                detailForm: {},
                isEdit:false,
            }
        },

        watch: {
            parentId(){
                this.getDetail()
            }
        },

        computed: {
            dictionary() {
                return this.$store.state.dictionary2
            },
            type_list() {
                return this.dictionary.app_type
            },
            query() {
                return this.$route.query
            },
            parentId() {
                return this.query.id
            }
        },

        created() {
            this.getDetail()
        },

        methods: {
            isEdited(){
                this.isEdit=true
            },
            getDetail() {
                services.nodeInfo({appId:this.parentId})
                    .then(res => {
                        this.detailForm = {
                            ...res,
                            superviser: res.superviser.map(item => item.name).join(','),
                            mail: res.mail.map(item => item.mail).join(',')
                        }
                        if (this.isEdit){
                            this.$route.query.callback()
                            this.isEdit=false
                        }
                    })
                    .catch(err => this.$message.error(err.message))
            },

            // 删除按钮
            handleDel(count) {
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => services.deleteMenu(count))
                    .then(() => {
                        this.$message.success('删除成功')
                        this.$route.query.callback()
                        this.$router.push({
                            path: '/appcenterTree'
                        })
                    })
                    .catch((err) => {err ? this.$message.error(err.message): this.$message.info('已取消删除')})
            },
        }

    }
</script>

<style scoped>
    .el-table {
        width: 99.9%
    }

</style>
